import { loadShared } from './dashboardCache';

// What a click on a person's "Admissions" count on Sales Cycle Length opens: the admissions behind the number (see
// sales_cycle_admissions.controller.js on the server). One place builds the URL, so the page that PREFETCHES on hover and the
// popup that LOADS on click share the very same remembered answer (dashboardCache.js).
export const salesCycleAdmissionsUrl = ({ userId, month }) => {
  const params = new URLSearchParams({ userId: String(userId), month: month.format('YYYY-MM-DD') });
  return `warning-dashboard/sales-cycle-admissions?${params.toString()}`;
};

// Warm the remembered answer (no UI): called when the pointer rests on a count, so by the click it is usually there.
export const prefetchSalesCycleAdmissions = (request) => {
  loadShared(salesCycleAdmissionsUrl(request)).catch(() => {});
};
